
import './style.scss';
import { Grid, Typography } from '@mui/material';
import { SignalCellularConnectedNoInternet1Bar } from '@mui/icons-material';
import { useLanguageContext } from '../../contexts/LanguageContext';
import DefaultConstants from '../../data/Constants';
import { IMuiIcon } from '../../interfaces/IMaterial';
import { useEffect } from 'react';
import DocumentHelper from '../../helpers/DocumentHelper';
import LanguagesSelector from '../Languages/LanguagesSelector';
import DateTimeHelper from '../../helpers/DateTimeHelper';


interface INotFoundProps {
    Icon?: IMuiIcon;
    description: string;
}


const NotFound: React.FC<INotFoundProps> = ({
    Icon = SignalCellularConnectedNoInternet1Bar,
    description
}) => {
    const { translate } = useLanguageContext();


    useEffect(() => {
        DocumentHelper.setTitle(DefaultConstants.systemName);
    }, []);


    return (
        <Grid container className='container-notfound'>
            <Grid item xs={12} className='grid-languages'>
                <LanguagesSelector />
            </Grid>

            <Grid item xs={12} className='grid-texts'>
                <Icon className='icon-title' />
                
                {
                    translate(description).split("\n").map((text: string, index: number) => {
                        return <Typography variant='subtitle1' className='text-subtitle' key={index}>
                            {text}
                        </Typography>;
                    })
                }
            </Grid>

            <Grid item xs={12} className='grid-developer'>
                <Typography component='h6' variant='subtitle2' className='fontsize-10 text-color-2'>
                    {translate('developedBy')}
                    <Typography component='span' variant='subtitle2' className='fontweight-600 fontsize-10'> {DefaultConstants.developer.name} </Typography>
                </Typography>

                <Typography component='h6' variant='subtitle2' className='fontsize-10 text-color-2'>
                    {translate('copyright').replace('{date}', DateTimeHelper.Now('YYYY'))}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default NotFound;